<template>
  <div id="account-not-active">
    <nav-bar-top icons-are-hidden />
    <div class="container has-nav-top-margin">
      <section
        v-if="!isEmailSent"
        class="section no-pad-bottom"
      >
        <h4 class="title is-4">
          Please activate your account to access SideSearch
        </h4>
        <p>We sent you an activation link, please check your email. If you have not received an activation email, click below to re-send it</p>
      </section>
      <section
        v-else-if="isEmailSent"
        class="section no-pad-botton"
      >
        <h4 class="title is-4">
          Success!
        </h4>
        <p>We've sent you an email to activate your account.</p>
      </section>
      <section
        v-if="!isEmailSent"
        class="section"
      >
        <button
          class="button is-rounded is-primary has-text-weight-bold"
          :class="isLoading ? 'is-loading' : ''"
          @click="handleSendActivationEmail"
        >
          Resend Activation Email
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';

export default {
  name: 'AccountNotActive',
  components: {
    NavBarTop
  },
  data () {
    return {
      isLoading: false,
      isEmailSent: false,
      isErrorSendingEmail: false
    };
  },
  computed: {
    account () {
      return this.$store.state.user.account;
    }
  },
  methods: {
    handleSendActivationEmail () {
      this.isLoading = true;
      this.$store.dispatch('reSendActivationEmail', { user: this.account })
        .then(response => {
          this.isLoading = false;
          this.isEmailSent = true;
        })
        .catch(error => {
          console.log('Error Sending Activation Email', error);
          this.isLoading = false;
          this.isErrorSendingEmail = true;
        });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
